/**
 * Whitelist каналов продвижения по нишам, рынок Казахстан.
 * Источник: marketdir_niche_research_kz.xlsx (лист «Каналы»).
 *
 * Это ограничение для ИИ: тактику внутри канала он придумывает свободно,
 * но добавлять каналы, которых здесь нет, не должен.
 */

export const MARKET_OVERVIEW_KZ = {
  note:
    'Поиск, соцсети и карты держат больше 90% рекламного бюджета малого бизнеса в Казахстане.',
  shares: [
    { channel: 'Поиск (Google, Яндекс)', share: 37.6 },
    { channel: 'Соцсети (Instagram, TikTok)', share: 36.2 },
    { channel: 'Карты (2GIS)', share: 16.8 },
  ],
  hints: [
    'TikTok: 14–15,7 млн пользователей в Казахстане, показы в 3–4 раза дешевле Instagram, заявка 700–1 500 ₸.',
    'Instagram: 12,1–12,4 млн пользователей, клик 150–400 ₸, заявка 1 500–5 000 ₸.',
    'Контент на казахском языке собирает на 30–40% больше охвата.',
  ],
  source: 'Ppc.world 2025; Metrium.kz 2026; Alataucitybank.kz 2026',
};

export const NICHE_CHANNELS = {
  retail_offline: {
    channels: [
      { id: '2gis', name: '2GIS', purpose: 'Локальный поиск — вас находят рядом' },
      { id: 'instagram', name: 'Instagram', purpose: 'Витрина товара и предложения' },
      { id: 'tiktok', name: 'TikTok', purpose: 'Дешёвый охват, короткие видео' },
      { id: 'kaspi', name: 'Kaspi Маркетинг', purpose: 'Если товар продаётся на Kaspi Magazin' },
      { id: 'whatsapp', name: 'WhatsApp Business', purpose: 'Заказы и консультации' },
    ],
    budgetNote: 'Kaspi Маркетинг: минимальная ставка клика 3 ₸, оплата только за клик, 20 000 бонусов на старт.',
    source: 'Marketing.kaspi.kz, Guide.kaspi.kz (2026)',
  },
  ecommerce: {
    channels: [
      { id: 'kaspi', name: 'Kaspi Маркетинг', purpose: 'Реклама внутри Kaspi Magazin' },
      { id: 'instagram', name: 'Instagram', purpose: 'Таргет на карточки товаров' },
      { id: 'tiktok', name: 'TikTok', purpose: 'Дешёвый охват и вирусные видео' },
      { id: 'search', name: 'Google / Яндекс', purpose: 'Реклама по горячим запросам' },
      { id: 'remarketing', name: 'Email и WhatsApp-напоминания', purpose: 'Возврат брошенных корзин' },
    ],
    budgetNote: 'Kaspi — оплата за клик от 3 ₸. Соцсети: клик 150–400 ₸, заявка 700–5 000 ₸.',
    source: 'Marketing.kaspi.kz; Metrium.kz 2026',
  },
  horeca: {
    channels: [
      { id: '2gis', name: '2GIS', purpose: 'Критично: запрос «кафе рядом»' },
      { id: 'instagram', name: 'Instagram', purpose: 'Визуальный контент и сторис' },
      { id: 'tiktok', name: 'TikTok', purpose: 'Короткие видео о заведении' },
      { id: 'aggregators', name: 'Агрегаторы доставки', purpose: 'Wolt, Яндекс Еда, Choco — с учётом их комиссии' },
      { id: 'whatsapp', name: 'WhatsApp', purpose: 'Бронирование столов' },
    ],
    budgetNote: 'Комиссию агрегаторов уточняйте индивидуально — по Казахстану единых данных нет.',
    source: 'Общий вывод из отраслевых источников',
  },
  beauty: {
    channels: [
      { id: 'instagram', name: 'Instagram', purpose: 'Портфолио мастеров, работы «до и после»' },
      { id: 'tiktok', name: 'TikTok', purpose: 'Процесс работы, дешёвый охват' },
      { id: '2gis', name: '2GIS', purpose: 'Поиск салона рядом с домом' },
      { id: 'whatsapp', name: 'WhatsApp Business', purpose: 'Запись и напоминания' },
      { id: 'referral', name: 'Программа «приведи подругу»', purpose: 'Рекомендации действующих клиентов' },
    ],
    budgetNote: 'Рекомендуемый бюджет рекламы 100 000–200 000 ₸ в месяц; ведение соцсетей от 150 000 ₸.',
    source: 'Metrium.kz 2026',
  },
  medical: {
    channels: [
      { id: 'search', name: 'Google / Яндекс', purpose: 'Запросы вроде «стоматолог рядом» — люди уже ищут' },
      { id: '2gis', name: '2GIS', purpose: 'Поиск клиники рядом' },
      { id: 'instagram', name: 'Instagram', purpose: 'Экспертный контент и отзывы' },
      { id: 'referral', name: 'Рекомендации пациентов', purpose: 'Самый дешёвый источник в медицине' },
    ],
    budgetNote: 'Заявка: 500–2 500 ₸ на простые услуги, 10 000–50 000 ₸ на сложные (импланты).',
    source: 'Vc.ru «Лидогенерация для стоматологии» (KZ)',
  },
  education: {
    channels: [
      { id: 'instagram', name: 'Instagram', purpose: 'Реклама открытых уроков и вебинаров' },
      { id: 'tiktok', name: 'TikTok', purpose: 'Короткие полезные видео как вход в воронку' },
      { id: 'messengers', name: 'WhatsApp и email-рассылки', purpose: 'Довести до оплаты после урока' },
      { id: 'partners', name: 'Партнёрские программы', purpose: 'Обмен аудиторией и рекомендации' },
    ],
    budgetNote: 'Ориентируйтесь на общие цены соцсетей: клик 150–400 ₸, заявка 700–5 000 ₸.',
    source: 'OSN.kz 2026; отраслевые кейсы vc.ru',
  },
  b2b: {
    channels: [
      { id: 'referral', name: 'Рекомендации', purpose: 'Основной канал по отраслевым данным' },
      { id: 'content', name: 'Контент и кейсы', purpose: 'Показываете результат — вам верят' },
      { id: 'networking', name: 'Нетворкинг и сообщества', purpose: 'Отраслевые встречи и чаты' },
      { id: 'search', name: 'Google / Яндекс', purpose: 'Ограниченно: только по конкретным запросам' },
    ],
    budgetNote: 'Бюджет сильно различается, единой оценки по Казахстану нет.',
    source: 'Metrium.kz (обзор B2B-маркетинга KZ, 2026)',
  },
  construction: {
    channels: [
      { id: '2gis', name: '2GIS', purpose: 'Поиск бригады рядом' },
      { id: 'instagram', name: 'Instagram', purpose: 'Портфолио объектов «до и после»' },
      { id: 'search', name: 'Google / Яндекс', purpose: 'Запросы вроде «ремонт квартиры цена»' },
      { id: 'referral', name: 'Рекомендации', purpose: 'Клиенты приводят соседей и знакомых' },
    ],
    budgetNote: 'Отдельных данных по нише нет — ориентируйтесь на общие цены соцсетей.',
    source: 'Общий вывод из отраслевых источников',
  },
  realestate: {
    channels: [
      { id: 'krisha', name: 'Krisha.kz', purpose: 'Основная площадка объявлений в Казахстане' },
      { id: '2gis', name: '2GIS', purpose: 'Поиск агентства рядом' },
      { id: 'instagram', name: 'Instagram', purpose: 'Объекты, экспертные разборы' },
      { id: 'referral', name: 'Рекомендации и своя база', purpose: 'Повторные клиенты риелтора' },
    ],
    budgetNote: 'Комиссия закладывается в экономику канала: 1–5% от сделки или 300 000–500 000 ₸ фиксом.',
    source: 'Inform.kz, Lada.kz (2025–2026)',
  },
  auto: {
    channels: [
      { id: '2gis', name: '2GIS', purpose: 'Критично: запрос «автосервис рядом»' },
      { id: 'instagram', name: 'Instagram', purpose: 'Работы, отзывы, цены' },
      { id: 'tiktok', name: 'TikTok', purpose: 'Короткие видео о ремонте' },
      { id: 'partners', name: 'Партнёрства', purpose: 'Страховые компании и автосалоны' },
      { id: 'loyalty', name: 'Программа лояльности', purpose: 'Возврат на повторное обслуживание' },
    ],
    budgetNote: 'Отдельных данных по нише нет — ориентируйтесь на общие цены соцсетей.',
    source: 'Общий вывод из отраслевых источников',
  },
};

export const getNicheChannels = (nicheId) => NICHE_CHANNELS[nicheId] || null;

export const getChannelWhitelist = (nicheId) => {
  const entry = getNicheChannels(nicheId);
  return entry ? entry.channels.map((channel) => channel.name) : [];
};

/**
 * Фразы, которые раздражают аудиторию: общий совет без цифры и без действия.
 * Используется как чёрный список при проверке ответа ИИ.
 */
export const BANNED_PHRASES = [
  'тестируйте гипотезы',
  'работайте над узнаваемостью',
  'повышайте лояльность',
  'используйте комплексный подход',
  'важно анализировать',
  'необходимо оптимизировать',
  'следите за трендами',
  'выстройте воронку',
];
